import React from 'react';
import {FaWhatsapp} from "react-icons/fa";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/51999202119"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-transform transform hover:scale-110 z-50"
      aria-label="Chatea por WhatsApp"
    >
      <FaWhatsapp size={70} />
    </a>
  );
};

export default WhatsAppButton;